var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AccordionItem, TemplateIcon, Text, TextInputField, } from '@/components';
import { TemplatePreview } from './template-preview';
export var TemplateConfig = function (_a) {
    var configuration = _a.configuration, setConfiguration = _a.setConfiguration, props = __rest(_a, ["configuration", "setConfiguration"]);
    return (_jsxs(AccordionItem, __assign({ label: _jsxs("div", { className: 'flex gap-2 items-center', children: [_jsx(TemplateIcon, {}), _jsx(Text, { variant: 'default', className: 'font-semibold', children: "Template Settings" })] }), className: 'w-full rounded-md border border-solid border-gray-300 overflow-hidden', headerClassName: 'p-2 bg-gray-300', containerClassName: 'p-4' }, props, { children: [_jsx(TemplatePreview, { selectedTemplate: configuration.templateId, onSelect: function (template) { return setConfiguration(__assign(__assign({}, configuration), { templateId: template })); } }), configuration.templateId === 2 && (_jsx(TextInputField, { name: 'template2BannerText', label: 'Banner Url', value: configuration.bannerUrl, type: 'url', placeholder: 'Enter banner url', onChange: function (e) { return setConfiguration(__assign(__assign({}, configuration), { bannerUrl: e.target.value })); } }))] })));
};
